'use strict';

const ERROR_MESSAGES = {
    sv: {
        EMAIL_IN_USE:
            'E-postadress används redan <a href="/login/enterusername" class="link" target="_blank">Glömt lösenord?</a>',
        ALIAS_IN_USE: 'Användarnamnet är upptaget',
        ALIAS_CONTAINS_RESERVED_WORD: 'Ogiltigt användarnamn',
        PERSONALID_IN_USE:
            'Ditt personnummer finns redan registrerat hos Tradera. <a href="/login/enteruserdetails" class="link" target="_blank">Få tillgång till ditt konto här</a>',
        ORGANIZATION_NUMBER_IN_USE: 'Det här organisationsnumret används redan',
        INVALID_EMAIL: 'Ogiltig e-postadress',
        INVALID_PERSONALID: 'Ogiltigt personnummer',
        INVALID_PHONENUMBER: 'Ogiltigt telefonnummer',
        INVALID_ALIAS: 'Ogiltigt användarnamn',
        INVALID_FIRSTNAME: 'Förnamnet är ogiltigt',
        INVALID_LASTNAME: 'Efternamnet är ogiltigt',
        INVALID_STREETNAME: 'Gatuadressen är ogiltigt',
        INVALID_ZIPCODE: 'Ogiltigt postnummer',
        INVALID_TOWN: 'Ogiltig Ort',
        INVALID_COMPANYNAME: 'Företagsnamnet är ogiltigt',
        REQUIRED_FIELD: 'Detta fält är tvingande',
        REQUIRED_EMAIL: 'Du behöver ange din e-postadress',
        REQUIRED_PERSONALID: 'Du behöver ange ditt personnummer',
        REQUIRED_FIRSTNAME: 'Du behöver ange ditt förnamn',
        REQUIRED_LASTNAME: 'Du behöver ange ditt efternamn',
        REQUIRED_ALIAS: 'Du behöver ange ett användarnamn',
        REQUIRED_STREETNAME: 'Du behöver ange din gatuadress',
        REQUIRED_ZIPCODE: 'Du behöver ange ditt postnummer',
        REQUIRED_TOWN: 'Du behöver ange din ort',
        REQUIRED_PHONENUMBER:
            'Ange ditt telefonnummer. Du kommer att använda det om du behöver återställa ditt lösenord',
        REQUIRED_COMPANYNAME: 'Du behöver ange företagets namn',
        MINLENGTH: '',
        MINLENGTH_FIRSTNAME: 'Förnamnet är för kort',
        MINLENGTH_LASTNAME: 'Efternamnet är för kort',
        MINLENGTH_COMPANYNAME: 'Företagets namn är för kort',
        MINLENGTH_ALIAS: 'Användarnamnet är för kort',
        MINLENGTH_STREETNAME: 'Gatuadressen är för kort',
        MINLENGTH_TOWN: 'Orten är för kort',
        MAXLENGTH: '',
        MAXLENGTH_EMAIL: 'Din e-postadress får max vara 255 tecken',
        MAXLENGTH_FIRSTNAME: 'Ditt förnamn får max vara 30 tecken',
        MAXLENGTH_LASTNAME: 'Ditt efternamn får max vara 30 tecken',
        MAXLENGTH_COMPANYNAME: 'Ditt företagsnamn får vara max 40 tecken',
        MAXLENGTH_ALIAS: 'Ditt användarnamn får max vara 50 tecken',
        MAXLENGTH_STREETNAME: 'Din gatuadress får max vara 50 tecken',
        MAXLENGTH_TOWN: 'Din ort får max vara 36 tecken',
        INVALID_LENGTH_EMAIL: 'Din e-postadress måste vara 5-255 tecken',
        INVALID_LENGTH_FIRSTNAME: 'Ditt förnamn måste vara 1-30 tecken',
        INVALID_LENGTH_LASTNAME: 'Ditt efternamn måste vara 1-30 tecken',
        INVALID_LENGTH_COMPANYNAME: 'Ditt företagsnamn måste vara 2-40 tecken',
        INVALID_LENGTH_ALIAS: 'Ditt användarnamn måste vara 2-50 tecken',
        INVALID_LENGTH_STREETNAME: 'Din gatuadress måste vara 1-50 tecken',
        INVALID_LENGTH_TOWN: 'Din ort måste vara 1-36 tecken',
        PERSONAL_NUMBER_UNDER_AGE:
            'Du behöver vara 16 år för att skapa ett konto',
        PAYPAL_NOT_VERIFIED:
            'This e-mail address is not PayPal verified. Please make sure that your name and e-mail address is identical to the information registered with PayPal and that you have followed <a href="https://www.paypal.com/selfhelp/article/FAQ1219" class="link" target="_blank">the steps for verification.',
        INVALID_CHARACTERS: 'Endast latinska tecken är tillåtna.',
        FACEBOOK_ID_IN_USE: 'Facebook ID är upptaget',
        FACEBOOK_ID_DOES_NOT_MATCH_TOKEN:
            'Din Facebook-session är ogiltig, vänligen logga in igen.',
        EMAIL_ADDRESS_DOES_NOT_MATCH_FACEBOOK_TOKEN:
            'Din Facebook-session är ogiltig, vänligen logga in igen.',
        FACEBOOK_USER_ACCESS_TOKEN_INVALID:
            'Din Facebook-session är ogiltig, vänligen logga in igen.',
        FACEBOOK_USER_ACCESS_TOKEN_EXPIRED:
            'Din Facebook-session har löpt ut, vänligen logga in igen för att fortsätta.',
        FACEBOOK_USER_ACCESS_TOKEN_MISSING_REQUIRED_SCOPE_PUBLIC_PROFILE:
            'Din Facebook-session är ogiltig, vänligen logga in igen.'
    },
    en: {
        EMAIL_IN_USE:
            'This email is already taken. <a href="/login/enterusername" class="link">Did you forget your password?</a>',
        ALIAS_IN_USE: 'This username is already taken',
        ALIAS_CONTAINS_RESERVED_WORD: 'Invalid username',
        INVALID_EMAIL: 'Invalid email address',
        INVALID_PERSONALID: 'Invalid personal ID',
        INVALID_PHONENUMBER: 'Invalid phone number',
        INVALID_ALIAS: 'Invalid username',
        INVALID_FIRSTNAME: 'Invalid firstname',
        INVALID_LASTNAME: 'Invalid last name',
        INVALID_STREETNAME: 'Invalid street name',
        INVALID_ZIPCODE: 'Invalid zipcode',
        INVALID_TOWN: 'Invalid town',
        INVALID_COUNTRY: 'Invalid country',
        INVALID_COMPANYNAME: 'Invalid company name',
        REQUIRED_FIELD: 'This field is required',
        REQUIRED_EMAIL: 'Email address is required',
        REQUIRED_PERSONALID: 'Personal ID is required',
        REQUIRED_FIRSTNAME: 'First name is required',
        REQUIRED_LASTNAME: 'Last name is required',
        REQUIRED_ALIAS: 'Username is required',
        REQUIRED_STREETNAME: 'Street is required',
        REQUIRED_ZIPCODE: 'Zipcode is required',
        REQUIRED_TOWN: 'Town is required',
        REQUIRED_COUNTRY: 'Country is required',
        REQUIRED_PHONENUMBER: 'Phone number is required',
        REQUIRED_COMPANYNAME: 'Company name is required',
        MINLENGTH: '',
        MINLENGTH_FIRSTNAME: 'First name is too short',
        MINLENGTH_LASTNAME: 'Last name is too short',
        MINLENGTH_COMPANYNAME: 'Company name is too short',
        MINLENGTH_ALIAS: 'Username is too short',
        MINLENGTH_STREETNAME: 'Street is too short',
        MINLENGTH_TOWN: 'Town is too short',
        MAXLENGTH: '',
        MAXLENGTH_EMAIL: 'Email address should be max 255 characters',
        MAXLENGTH_FIRSTNAME: 'First name should be max 30 characters',
        MAXLENGTH_LASTNAME: 'Last name should be max 30 characters',
        MAXLENGTH_COMPANYNAME: 'Company name should be max 40 characters',
        MAXLENGTH_ALIAS: 'Username should be max 50 characters',
        MAXLENGTH_STREETNAME: 'Street should be max 50 characters',
        MAXLENGTH_TOWN: 'Town should be max 36 characters',
        INVALID_LENGTH_EMAIL: 'Email address should be 5-255 characters',
        INVALID_LENGTH_FIRSTNAME: 'First name should be 1-30 characters',
        INVALID_LENGTH_LASTNAME: 'Last name should be 1-30 characters',
        INVALID_LENGTH_COMPANYNAME: 'Company name should be 2-40 characters',
        INVALID_LENGTH_ALIAS: 'Username should be 2-50 characters',
        INVALID_LENGTH_STREETNAME: 'Street should be 1-50 characters',
        INVALID_LENGTH_TOWN: 'Town should be 1-36 characters',
        PERSONAL_NUMBER_UNDER_AGE: '',
        PAYPAL_NOT_VERIFIED:
            'This e-mail address is not PayPal verified. Please make sure that your name and e-mail address is identical to the information registered with PayPal and that you have followed <a href="https://www.paypal.com/selfhelp/article/FAQ1219" class="link" target="_blank">the steps for verification.',
        INVALID_CHARACTERS: 'Only Latin characters are allowed.',
        FACEBOOK_ID_IN_USE: 'Facebook ID is already taken',
        FACEBOOK_ID_DOES_NOT_MATCH_TOKEN:
            'Your Facebook session is invalid, please log in again.',
        EMAIL_ADDRESS_DOES_NOT_MATCH_FACEBOOK_TOKEN:
            'Your Facebook session is invalid, please log in again.',
        FACEBOOK_USER_ACCESS_TOKEN_INVALID:
            'Your Facebook session is invalid, please log in again.',
        FACEBOOK_USER_ACCESS_TOKEN_EXPIRED:
            'Your Facebook session has expired, please log in again.',
        FACEBOOK_USER_ACCESS_TOKEN_MISSING_REQUIRED_SCOPE_PUBLIC_PROFILE:
            'Your Facebook session is invalid, please log in again.'
    }
};

module.exports = ERROR_MESSAGES;
